import React, { useState } from "react";

// Speaker photo with a graceful fallback: if the URL is missing OR fails to
// load (broken link), we render a purple circle with the speaker's initial
// instead of the browser's broken-image icon. Used on the webinar listing
// card and the dedicated detail page.
export default function SpeakerAvatar({ name, photoUrl, size = 48 }) {
  const [broken, setBroken] = useState(false);
  const dim = { width: size, height: size };
  const showImg = photoUrl && !broken;

  if (showImg) {
    return (
      <img
        src={photoUrl}
        alt={name || "Instructor"}
        style={dim}
        onError={() => setBroken(true)}
        className="rounded-full object-cover shrink-0"
        data-testid="speaker-avatar-img"
      />
    );
  }
  return (
    <div
      style={dim}
      className="rounded-full bg-[#F0E7F4] grid place-items-center text-[#965EA7] font-bold shrink-0"
      data-testid="speaker-avatar-fallback"
    >
      {(name || "?").slice(0, 1).toUpperCase()}
    </div>
  );
}
